import { render, staticRenderFns } from "./SurchargeBreakdown.vue?vue&type=template&id=eb0d6c00"
import script from "./SurchargeBreakdown.vue?vue&type=script&lang=js"
export * from "./SurchargeBreakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports